import script from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=33e631a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e631a0"]])

export default __exports__